import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "LTLReceiversPanel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "LTLReceiversPanel__title" }, "Выберите получателя", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "LTLReceiversPanel__subtitle" }, " Уведомляем вас, что необходимо обновить шаблон. Пожалуйста перепроверьте перед загрузкой. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "LTLReceiversPanel__subtitle" }, " Если вы не нашли нужного получателя, просим вас обратиться к менеджеру. ", -1)
const _hoisted_5 = { class: "LTLReceiversPanel__header" }
const _hoisted_6 = {
  key: 0,
  class: "header__actions"
}
const _hoisted_7 = {
  class: "actions__action",
  href: "/Шаблон загрузки заказов.xlsx",
  download: ""
}
const _hoisted_8 = { class: "LTLReceiversPanel__scrollable scroll ltl" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "Новый получатель", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "Загрузить еще", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_search = _resolveComponent("icon-search")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_file_loader = _resolveComponent("file-loader")!
  const _component_icon_download = _resolveComponent("icon-download")!
  const _component_icon_big_plus = _resolveComponent("icon-big-plus")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_point_in_panel = _resolveComponent("point-in-panel")!
  const _component_panels_loader = _resolveComponent("panels-loader")!
  const _component_receiver_create = _resolveComponent("receiver-create")!
  const _component_s_modal = _resolveComponent("s-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.opened)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_s_input, {
              placeholder: "Поиск по номеру телефона, адресу или названию",
              value: _ctx.search_query,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search_query = $event)),
              onInput: _ctx.emitSearch
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_icon_search)
              ]),
              _: 1
            }, 8, ["value", "onInput"]),
            (!_ctx.disableExcel)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_file_loader, {
                    accept: ".xlsx, .xls, .csv",
                    "onUpdate:value": _ctx.emitCreateByExcel,
                    placeholder: "Загрузить из Excel",
                    loading: _ctx.excelLoading,
                    disabled: _ctx.blocked
                  }, null, 8, ["onUpdate:value", "loading", "disabled"]),
                  _withDirectives(_createVNode("a", _hoisted_7, [
                    _createVNode(_component_icon_download)
                  ], 512), [
                    [_directive_tooltip, { text: 'Скачать шаблон', theme: { direction: 'bottom' } }]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_s_button, {
              class: "scrollable__add primary",
              onClick: _ctx.startCreateReceiver
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon_big_plus),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, i) => {
              return (_openBlock(), _createBlock(_component_point_in_panel, {
                key: `LTLReceiverPointInPanel-${i}`,
                point: receiver,
                selected: _ctx.selectedReceiversIds.includes(receiver.id),
                blocked: _ctx.excelLoading || _ctx.blocked,
                isLTL: _ctx.isLTL,
                isFTL: _ctx.isFTL,
                onSelect: ($event: any) => (_ctx.emitSelect(receiver)),
                onEdit: _ctx.startEditReceiver,
                onDelete: _ctx.emitDelete
              }, null, 8, ["point", "selected", "blocked", "isLTL", "isFTL", "onSelect", "onEdit", "onDelete"]))
            }), 128)),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_panels_loader, { key: 0 }))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.current_page < _ctx.total_pages && !_ctx.isSearch)
                    ? (_openBlock(), _createBlock(_component_s_button, {
                        key: 0,
                        class: "scrollable__add primary",
                        onClick: _ctx.emitLoadMore
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 64))
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isReceiverActionsOpened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 1,
          onClose: _ctx.closeReceiverActions
        }, {
          body: _withCtx(() => [
            _createVNode(_component_receiver_create, {
              isLTL: _ctx.isLTL,
              isFTL: _ctx.isFTL,
              "sender-city-id": _ctx.senderCityId,
              onCreate: _ctx.createReceiverHandler,
              onUpdate: _ctx.updateReceiverHandler,
              onClose: _ctx.closeReceiverActions
            }, null, 8, ["isLTL", "isFTL", "sender-city-id", "onCreate", "onUpdate", "onClose"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}